import { h } from 'preact';

const Question = ({ handler, question, restart, questionNumber}) => {

    return (
        <div>
        <img style="padding-bottom:15px;" src="/assets/aon_logo_2.png"/>
            <button onClick={() => restart(true)} className="cursor-pointer d-flex btn btn-sm btn-outline-secondary">
                <i className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                </i>
                Start again
            </button>
            <img className="paddAbove" style="max-width:100%;" src="/assets/cdc-question-banner.png"/>

            <h3 className="paddAbove">{questionNumber()}. {question.label}</h3>
            <div className="list-group mt-4">
                {question.options.map((answer, answerIdx) => (
                    <a key={answerIdx} onClick={() => handler(question, answer)} className="cursor-pointer list-group-item list-group-item-action d-flex justify-content-start align-items-center text-dark">
                        <span className="badge badge-primary badge-pill mr-3">{ answerIdx + 1}</span>
                        <p className="mb-0">{ answer.label }</p>
                    </a>
                ))}
            </div>
        </div>

    );
}

export default Question;
